export const adExtensionPage = {
  id: 'adExtensions',
  name: _TL_('Ad Extensions'),
  route: 'hotelcenter/calloutextensions',
  checkPermission: permissions => permissions.dynamic.HotelAds,
};
